import { useDispatch, useSelector } from "react-redux";
import {
    closePanels,
    closeGalleryOfService,
    closeTopPanel,
    hideContact,
    hideFaq,
    hidePrivateService,
    hideSectionBanner,
    hideServiceList,
    hideTeamsMenu,
    setSection,
    showContentSection,
    showHeroBanner,
    toggleHeroService,
    startPanelInfoFade,
    hideAcceptingForm,
    showAcceptingForm,
    collapseContentSection
} from "../features/serviceSlice";
import "./Header.css";
import { toSlug } from "../utils/slug";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function PanelInfoHeader() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [openMenu, setOpenMenu] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileMenuBlurVisible, setIsMobileMenuBlurVisible] = useState(false);
    const [selectedMobileMenuId, setSelectedMobileMenuId] = useState(null);
    const [pendingServiceSlug, setPendingServiceSlug] = useState(null);
    const mobileMenuTimerRef = useRef(null);
    const {
        showInfo,
        activeSection,
        serviceList,
        expanded,
        switchServiceList,
        showTopHeroBanner,
        serviceData,
        isPanelInfoFading
    } = useSelector(state => state.service);
    const mobileMenuTransitionMs = 520;
    const currentServiceSlug = location.pathname.startsWith("/services")
        ? location.pathname.split("/").filter(Boolean)[1]
        : null;
    const activeServiceSlug = pendingServiceSlug || currentServiceSlug;

    useEffect(() => {
        return () => {
            if (mobileMenuTimerRef.current) {
                clearTimeout(mobileMenuTimerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        setPendingServiceSlug(null);
    }, [location.pathname]);

    const clearMobileMenuTimer = () => {
        if (mobileMenuTimerRef.current) {
            clearTimeout(mobileMenuTimerRef.current);
            mobileMenuTimerRef.current = null;
        }
    };

    const closeMobileMenu = () => {
        clearMobileMenuTimer();
        setIsMobileMenuOpen(false);
        setSelectedMobileMenuId(null);
        mobileMenuTimerRef.current = setTimeout(() => {
            setOpenMenu(null);
            setIsMobileMenuBlurVisible(false);
            mobileMenuTimerRef.current = null;
        }, mobileMenuTransitionMs);
    };

    const openMobileServiceMenu = (section) => {
        clearMobileMenuTimer();

        if (openMenu?.id === section.id && isMobileMenuOpen) {
            closeMobileMenu();
            return;
        }

        setSelectedMobileMenuId(section.id);

        if (isMobileMenuOpen) {
            setIsMobileMenuOpen(false);
            setIsMobileMenuBlurVisible(true);
            mobileMenuTimerRef.current = setTimeout(() => {
                setOpenMenu(section);
                requestAnimationFrame(() => setIsMobileMenuOpen(true));
                mobileMenuTimerRef.current = null;
            }, mobileMenuTransitionMs);
            return;
        }

        setOpenMenu(section);
        setIsMobileMenuBlurVisible(true);
        requestAnimationFrame(() => setIsMobileMenuOpen(true));
    };

    const runPanelNavTransition = (nextTitle) => {
        if (isPanelInfoFading) return;
        setPendingServiceSlug(toSlug(nextTitle));
        dispatch(startPanelInfoFade());
        setTimeout(() => {
            dispatch(closeGalleryOfService());
            dispatch(showContentSection());
            dispatch(setSection(nextTitle));
            dispatch(hideTeamsMenu());
            dispatch(closePanels());
            dispatch(hideFaq());
            dispatch(hideContact());
            dispatch(hidePrivateService());
            setTimeout(() => {
                dispatch(setSection(nextTitle));
            }, 400);
            if (activeSection !== nextTitle) {
                dispatch(hideSectionBanner());
                dispatch(hideServiceList());
                setTimeout(() => {
                    navigate(`/services/${toSlug(nextTitle)}`);
                }, 900);
            } else {
                navigate(`/services/${toSlug(nextTitle)}`);
            }
        }, 320);
    };

    const mobileMenuLayer = (
        <>
            <div
                className={`mobile-menu-page-blur ${isMobileMenuBlurVisible ? "open" : ""}`}
                onClick={closeMobileMenu}
            />
            <div className={`pullDownMobileMenu ${isMobileMenuOpen ? "open" : "closed"} ${isMobileMenuBlurVisible ? "has-shadow" : ""}`}>
                <ul>
                    {openMenu && openMenu.items.map((p, index) => (
                        <li
                            key={index}
                            onClick={(e) => {
                                e.stopPropagation();
                                dispatch(hideAcceptingForm());
                                closeMobileMenu();
                                dispatch(closeGalleryOfService());
                                dispatch(showContentSection());
                                setPendingServiceSlug(toSlug(openMenu.title));
                                navigate(
                                    `/services/${toSlug(openMenu.title)}/${toSlug(p.label)}`
                                );
                            }}
                        >
                            {p.label}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );

    return (
        <>
            <header className="blacklabel-header panel-info-header-root">
                <nav className={`nav-left ${!serviceList && !expanded && !switchServiceList && !showTopHeroBanner ? "d-none" : ""}`}>
                    {serviceData?.length ? (
                        serviceData.map((x) => (
                            <span
                                key={x.id}
                                className={
                                    selectedMobileMenuId === x.id ||
                                    (!selectedMobileMenuId && activeServiceSlug === toSlug(x.title))
                                        ? "nav-service-active"
                                        : ""
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (window.innerWidth < 768) {
                                        openMobileServiceMenu(x);
                                        return;
                                    }
                                    runPanelNavTransition(x.title);
                                }}
                            >
                                {x.title.split(" ")[0]}
                            </span>
                        ))
                    ) : (
                        <span style={{ opacity: 0 }}>PLACEHOLDER</span>
                    )}
                </nav>

                <div className="nav-right">
                    <p className="member1" onClick={(e) => {
                        e.stopPropagation();
                        closeMobileMenu();
                        dispatch(showAcceptingForm());
                    }}>RESERVE</p>
                    <p className="accepting-header-btn" onClick={(e) => {
                        e.stopPropagation();
                        closeMobileMenu();
                        dispatch(showAcceptingForm());
                        if (window.innerWidth > 840) {
                            dispatch(collapseContentSection());
                        }
                    }}>
                        RESERVE
                    </p>

                    <div
                        className="hamburger"
                        onClick={(e) => {
                            e.stopPropagation();
                            if (window.innerWidth < 768 && isMobileMenuOpen) {
                                closeMobileMenu();
                            }
                            dispatch(showContentSection());
                            dispatch(hideAcceptingForm());
                            dispatch(hideSectionBanner());

                            if (showInfo) {
                                dispatch(closeTopPanel())
                                dispatch(showHeroBanner())
                                dispatch(hideTeamsMenu())
                                navigate(`/services`)
                            } else {
                                dispatch(toggleHeroService())
                                dispatch(hideSectionBanner())
                                dispatch(hideTeamsMenu())
                                dispatch(showHeroBanner())
                                dispatch(hidePrivateService())
                                setTimeout(() => {
                                    navigate(`/services`)
                                }, 900)

                            }
                        }}
                    >
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </header>

            {typeof document !== "undefined"
                ? createPortal(mobileMenuLayer, document.body)
                : mobileMenuLayer}
        </>
    );
}
